import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCjPKU23OsMYaLeEHiKWT_tjUgp-Cm9urI",
  authDomain: "maltaopenapplications.firebaseapp.com",
  databaseURL: "https://maltaopenapplications.firebaseio.com",
  projectId: "maltaopenapplications",
  storageBucket: "maltaopenapplications.appspot.com",
  messagingSenderId: "232337280677",
  appId: "1:232337280677:web:ade5cdefcb476a8647074c"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
